<div class="page-container">
  <form>
    <app-text-input [control]="getControl('name')" [label]="'Lernset-Name' | translate" [placeholder]="'Name des Lernsets eingeben'"></app-text-input>
    <div class="buttons-container">
      <app-button [text]="'Lernset erstellen'" type="button" (click)="saveLearnset()" [loading]="isLoading"></app-button>
    </div>
  </form>
</div>